/**
 * Persistent in-memory cache for profile data.
 * Persists across component remounts and tab switches.
 * Only refetch when cache is empty (e.g. first load or after sign-out).
 */

/** Profile row from Supabase (shared with useProfile) */
export interface Profile {
  id: string;
  email: string;
  display_name: string | null;
  avatar_url: string | null;
  dietary_preferences: string[];
  allergies: string[];
  default_servings: number;
  measurement_system: 'metric' | 'imperial';
  household_id: string | null;
  onboarding_completed: boolean;
  created_at: string;
  updated_at: string;
}

const profileByUserIdCache: { [userId: string]: Profile } = {};

/** Get profile from cache */
export function getCachedProfile(userId: string): Profile | null {
  if (!userId) return null;
  return profileByUserIdCache[userId] ?? null;
}

/** Store profile in cache */
export function setCachedProfile(profile: Profile): void {
  if (!profile?.id) return;
  profileByUserIdCache[profile.id] = profile;
}

/** Remove profile from cache (e.g. on sign-out) */
export function removeCachedProfile(userId: string): void {
  delete profileByUserIdCache[userId];
}
